module.exports = __webpack_public_path__ + "static/media/arrow-angle-up.a819d6d0.svg";